import { gql } from "@apollo/client";

export const PLATFORM_HOME_SUMMARY_QUERY = gql`
  query PlatformHomeSummary(
    $territoryIds: [ID!]
    $dateFrom: String
    $dateTo: String
    $metric: String
    $erosionIndicateurId: ID!
  ) {
    platformHomeSummary {
      projectTitle
      projectDescription
      lastUpdatedAt
      reportCount
      measureCount
      indicatorCount
      territoryCount
      coverageRatio
      insightCount
      alertCount
      validatedElements
      toReviewElements
      missingElements
      report {
        id
        title
        date
        sourceUri
        status
        pageCount
        version
        language
      }
      priorityInsights {
        id
        kind
        label
        severity
        algorithmOrQuery
        sourceMesureIds
        createdAt
      }
      kpis {
        validatedMeasureCount
        indicatorWithDataCount
        coverageRatio
        territoryCount
        latestYear
        alertCount
        economicTotalVet
        economicUnit
        erosionPerceptionPct
        cultivatedVariationPct
        forestClearVariationPct
      }
    }
    landCoverSeries(
      territoryIds: $territoryIds
      metric: $metric
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      unit
      points {
        mesureId
        periodStart
        value
        unit
        territoryId
        territoryLabel
        dimensions {
          type
          code
          label
        }
      }
    }
    erosionDistribution: indicatorDistribution(
      indicateurId: $erosionIndicateurId
      territoryIds: $territoryIds
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      sampleSize
      territoryLabel
      buckets {
        modalityLabel
        value
        unit
        mesureId
      }
    }
  }
`;

export const DASHBOARD_COCKPIT_QUERY = gql`
  query DashboardCockpit(
    $territoryIds: [ID!]
    $serviceIds: [ID!]
    $dateFrom: String
    $dateTo: String
    $metric: String
    $erosionIndicateurId: ID!
    $vetIndicateurId: ID!
    $comparisonIndicateurId: ID!
    $comparisonTerritories: [ID!]!
    $donutTerritoryId: ID!
    $snapshotYear: String!
    $radarTerritoryIds: [ID!]!
  ) {
    dashboardKpis(
      filters: {
        territoryIds: $territoryIds
        serviceIds: $serviceIds
        dateFrom: $dateFrom
        dateTo: $dateTo
      }
    ) {
      validatedMeasureCount
      indicatorWithDataCount
      coverageRatio
      territoryCount
      latestYear
      alertCount
      economicTotalVet
      economicUnit
      erosionPerceptionPct
      cultivatedVariationPct
      forestClearVariationPct
    }
    availableFilterOptions(context: N1) {
      territories {
        id
        kind
        label
      }
      services {
        id
        libelle
        categorie
        prioritaire
      }
      indicateurs {
        id
        libelle
        uniteDefaut
      }
      years
    }
    landCoverSeries(
      territoryIds: $territoryIds
      metric: $metric
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      unit
      points {
        mesureId
        periodStart
        value
        unit
        territoryId
        territoryLabel
        dimensions {
          type
          code
          label
        }
      }
    }
    dashboardInsights(
      filters: {
        territoryIds: $territoryIds
        serviceIds: $serviceIds
        dateFrom: $dateFrom
        dateTo: $dateTo
      }
    ) {
      id
      kind
      label
      severity
      algorithmOrQuery
      sourceMesureIds
      createdAt
    }
    erosionDistribution: indicatorDistribution(
      indicateurId: $erosionIndicateurId
      territoryIds: $territoryIds
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      sampleSize
      territoryLabel
      buckets {
        modalityLabel
        value
        unit
        mesureId
      }
    }
    economicSeries: indicatorSeries(
      indicateurId: $vetIndicateurId
      territoryIds: $territoryIds
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      unit
      points {
        mesureId
        periodStart
        value
        unit
        territoryLabel
      }
    }
    indicatorCoverage(
      filters: {
        territoryIds: $territoryIds
        serviceIds: $serviceIds
        dateFrom: $dateFrom
        dateTo: $dateTo
      }
    ) {
      completenessRatio
      cells {
        indicateurId
        indicateurLibelle
        territoryId
        territoryLabel
        periodYear
        status
        mesureCount
      }
    }
    territoryComparison: indicatorComparison(
      indicateurId: $comparisonIndicateurId
      territoryIds: $comparisonTerritories
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      indicateurId
      libelle
      unit
      cells {
        territoryId
        territoryLabel
        periodStart
        value
        unit
        mesureId
      }
    }
    landCoverDistribution(territoryId: $donutTerritoryId, year: $snapshotYear, unit: "%") {
      territoryId
      territoryLabel
      year
      unit
      total
      anomaly
      segments {
        code
        label
        value
        unit
        mesureId
        grouped
      }
      detailSegments {
        code
        label
        value
        unit
        mesureId
        grouped
      }
    }
    territoryProfiles(territoryIds: $radarTerritoryIds, year: $snapshotYear) {
      year
      comparableAxisCount
      profiles {
        territoryId
        territoryLabel
        year
        axes {
          axisId
          axisLabel
          rawValue
          rawUnit
          normalizedValue
          normalizationMethod
          period
          source
          mesureId
        }
      }
    }
  }
`;
